import {Dialog, DialogContent, Typography, Box, Button} from "@mui/material";
import "./Modal.css";

const Modal = ({
    open,
    onClose,
    preTitle,
    title,
    disabled,
    description,
    primaryButtonText,
    secondaryButtonText,
    onPrimaryClick,
    onSecondaryClick,
}) => {
    return (
        <Dialog open={open} onClose={onClose} fullWidth className="Modal">
            <DialogContent className="Modal-content">
                {preTitle && (
                    <Typography component="div" className="Modal-pretitle">
                        <span className="Modal-pretitle__slash" />
                        {preTitle}
                    </Typography>
                )}

                {title && (
                    <Typography variant="h1" className="Modal-title">
                        {title}
                    </Typography>
                )}

                {description && (
                    <Typography variant="body1" className="Modal-description">
                        {description}
                    </Typography>
                )}

                <Box className="Modal-actions">
                    {secondaryButtonText && (
                        <Button
                            disabled={disabled}
                            variant="outlined"
                            onClick={onSecondaryClick || onClose}
                            className="Modal-secondaryButton"
                        >
                            {secondaryButtonText}
                        </Button>
                    )}

                    {primaryButtonText && (
                        <Button
                            disabled={disabled}
                            variant="accent"
                            onClick={onPrimaryClick || onClose}
                            className="Modal-primaryButton"
                        >
                            {primaryButtonText}
                        </Button>
                    )}
                </Box>
            </DialogContent>
        </Dialog>
    );
};

export default Modal;
